<template>
    <div id="triggerZone">
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
        ></loading>
        <div class="scroll-list" style="{'height': topicsListHeight+104 + 'px'}">
            <div class="triggers-list">
                <draggable :triggersList="triggersList" v-model="sortedLanguages" :disabled="!enabled" @update="onUpdate" class="list-group" ghost-class="ghost" :move="checkMove" @start="dragging = true">
                    <div class="list-item" style="margin-bottom:5%;" v-for="(trigger, index) in triggersList" v-if="trigger.toiId === currentTopic.id" v-on:mouseover="hoverOn(index,trigger.name)" v-on:mouseleave="hoverOff(index)">
                        <md-button @click="navToTriggerSettings(trigger)">
                            <div class="line-item title-line">
                                <div class="left-item">
                                    <span>
                                        <span v-if="trigger.activeInactiveImages === 1">
                                            <img class="completeImages" src="static/img/complete.png">
                                        </span>
                                        <span v-else>
                                            <img class="inCompleteImages" style="width :13px" src="static/img/inComplete.png">
                                        </span>
                                        {{ trigger.name }}
                                    </span>
                                </div>
                                <div class="right-item">
                                    <div class="el lock-el" ng-show="item.lock">
                                        <i class="icon icon-lock_outline" style="margin-left:20px; float:right;"></i>
                                    </div>
                                    <div class="el">
                                        <md-menu>
                                            <md-button md-menu-trigger class="md-icon-button">
                                                <md-icon title="Options">more_vert</md-icon>
                                            </md-button>
                                            <md-menu-content width="3" v-if="trigger.on_off == 1">
                                                <md-menu-item>
                                                    <md-button @click="loadStoryFiles(trigger.storyName,trigger.storyNameCopy,trigger.routeId, trigger.id, trigger.toiId)">Show Story Files</md-button>
                                                </md-menu-item>
                                                <md-menu-item>
                                                    <md-button @click="copyTriggerZone(trigger.id)">Duplicate TriggerZone</md-button>
                                                </md-menu-item>
                                                <md-menu-item>
                                                    <md-button v-if="!showChilddData.includes(index)" @click="MoreInfoFunction(trigger.id , index)">Add More Info</md-button>
                                                    <md-button v-if="showChilddData.includes(index)" @click="confirmDeleteMore(trigger.id , index)">Remove More Info</md-button>
                                                </md-menu-item>
                                                <md-menu-item>
                                                    <md-button @click="confirmDelete(trigger.id, index)">Delete</md-button>
                                                </md-menu-item>
                                            </md-menu-content>
                                        </md-menu>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <span v-if="trigger.on_off == 0" style="color:red;">OFF</span>
                                </div>
                            </div>
                        </md-button>
                        <div class="left-item">
                            <span v-if="stories.length > 0  && trigger.file_name !== '' && trigger.file_type==0" class="show-lengthTrigger">
                                <small> {{ trigger.file_length }} </small>
                                <small>
                                    <img @click="trigger.on_off == 0 ? '': playVideMp3(trigger.file_name , trigger.file_type)" class="videoPLayIcon" src="static/img/playicon.png"/>
                                </small>
                            </span>
                            <span v-if="stories.length > 0  && trigger.file_name == ''" class="show-lengthTrigger"></span>
                        </div>
                        <span @click="navToTriggerSettings(trigger)">
                            <div class="line-item title-line">
                                <div class="right-item">
                                    <span v-if="triggernotesids.includes(trigger.id)" style="margin-right: 31px;">
                                        <img @click="goChangeNote(trigger)" v-bind:src="'/static/img/note_icon.jpg'" class="icon-note"/>
                                    </span>
                                </div>
                            </div>
                        </span>
                        <div class="select-wrap">
                            <md-field>
                                <md-select :disabled="trigger.on_off == 0" v-model="trigger.storyName" placeholder="Select a story..." v-if="stories.length > 0 " :change="assignStoryToTrigger(trigger,trigger.routeId)">
                                    <md-option v-for="(story, index) in stories" :value="story.friendly_name" :key="story.friendly_name">{{ story.friendly_name }}
                                        <md-icon class="list-icon" v-if="story.isVideo === 1" v-html="rawIcon"></md-icon>
                                    </md-option>
                                </md-select>
                                <div v-else>No stories available.</div>
                            </md-field>
                            <div v-if="trigger.file_name_video" @click="playVideMp3(trigger.file_name_video , trigger.file_type_video)">
                                <md-icon class="vid-icon" title="This story has video">videocam</md-icon>
                            </div>
                        </div>
                        <div class="select-wrap" v-if="showChilddData.includes(index)">
                            <md-field>
                                <md-select :disabled="trigger.on_off == 0" v-model="trigger.storyNameCopy" placeholder="Select a story..." v-if="stories.length > 0" :change="assignStoryToTriggerCopy(trigger,1,trigger.routeId)">
                                    <md-option v-for="(story, index) in stories" :value="story.friendly_name" :key="story.friendly_name" v-if="story.isVideo !== 1">
                                        {{ story.friendly_name }}
                                        <md-icon class="list-icon" v-if="story.isVideo === 1" v-html="rawIcon"></md-icon>
                                    </md-option>
                                </md-select>
                                <div v-else>No stories available.</div>
                            </md-field>
                            <div v-if="triggerHasVideo(trigger.storyNameCopy)">
                                <md-icon class="vid-icon" title="This story has video">videocam</md-icon>
                            </div>
                            <img class="more_info_icon" :src="'/static/img/More_info_Icon.png'">
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <footer class="aside-btn">
            <div class="btn-wrap new-trigger-zone">
                <md-button class="md-raised md-primary" @click="createTriggerZone">New Trigger Zone</md-button>
            </div>
        </footer>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogChannel">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
                Please choose at least one channel before creating TriggerZone.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogChannel = false">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this trigger?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="clickDeleteTrigger(triggerIdDelete, indexDataDelete)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogMore">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to remove more info?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="removeMoreInfoFunction(triggerIdDelete, indexDataDelete)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogMore = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <modal name="video-file-play" resizable="true" class="full-size-video">
            <div class="row">
                <div class="md-dialog-container" tabindex="-1">
                    <div class="boxes" tabindex="-1">
                        <video ref="videoRef" v-bind:src="this.vedioSrc" id="video-container" width="100%" controls></video>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="audio-file-play" resizable="true">
            <div class="row">
                <div class="md-dialog-container" tabindex="-1">
                    <div class="boxes" tabindex="-1">
                        <audio-player class="audioFile" :file="file1"></audio-player>
                    </div>
                </div>
            </div>
        </modal>
        <md-dialog :md-click-outside-to-close="false" resizable="true" :md-active.sync="showModalForTrgPass">
            <md-dialog-title>
                Create Password For ({{ triggerZonePassName }})
            </md-dialog-title>
            <md-dialog-content>
                <md-input name="first-name" type="password" id="first-name" autocomplete="given-name" v-model="triggerZonePassword"/>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="insertPassForTrigger(triggerZonePassId, triggerZonePassName)">submit</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showModalForTrgPass = false">Cancel</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import draggable from 'vuedraggable';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {deleteTrigger, removeMoreInfo, triggerIdsNotes, copyTrigger, checkChannels, saveTriggerOrder} from '../../services/TriggerService.js';

const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};
const AudioPlayer = {
  template: `
        <div class="player">
        <div class="player-controls">
            <div><a v-on:click.prevent="stop" title="Stop" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="playing = !playing" title="Play/Pause" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!playing" fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"/>
                    <path v-else fill="currentColor" d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"/>
                </svg>
            </a></div>
            <div>
                <div v-on:click="seek" class="player-progress" title="Time played : Total time">
                    <div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
                </div>
                <div class="player-time">
                    <div class="player-time-current">{{ currentTime }}</div>
                    <div class="player-time-total">{{ durationTime }}</div>
                </div>
            </div>
            <div><a v-on:click.prevent="download" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="innerLoop = !innerLoop" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!innerLoop" fill="currentColor" d="M1,12V5h3v6h10V8l5,4.5L14,17v-3H3C1.895,14,1,13.104,1,12z"/>
                    <path v-else fill="currentColor" d="M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4C19.104,5,20,5.896,20,7z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="mute" title="Mute" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path v-if="!muted" fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"/>
                    <path v-else fill="currentColor" d="M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"/>
                </svg>
            </a></div>
            <div><a v-on:click.prevent="" v-on:mouseenter="showVolume = true" title="Volume" href="#">
                <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path fill="currentColor" d="M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"/>
                </svg>
                <input v-model.lazy.number="volume" v-show="showVolume" type="range" min="0" max="100"/></a></div>
        </div>
        <audio :loop="innerLoop" ref="audiofile" :src="file" preload="auto" style="display: none;"></audio>
        </div>`,
  props: {
    file: {
      type: String,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    audio: undefined,
    currentSeconds: 0,
    durationSeconds: 0,
    innerLoop: false,
    loaded: false,
    playing: false,
    previousVolume: 35,
    showVolume: false,
    volume: 100
  }),
  computed: {
    currentTime () {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime () {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete () {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted () {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing (value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume (value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download () {
      this.stop();
      window.open(this.file, 'download');
    },
    load () {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },
    mute () {
      if (this.muted) {
        this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek (e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }
      const el = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - el.left) / el.width;
      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop () {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update (e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  created () {
    this.innerLoop = this.loop;
  },
  mounted () {
    this.audio = this.$el.querySelectorAll('audio')[0];
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', () => {
      this.playing = false;
    });
    this.audio.addEventListener('play', () => {
      this.playing = true;
    });
  }
};

export default {
  data: () => ({
    triggersListTemp: '',
    enabled: true,
    dragging: false,
    iconClick: false,
    rawIcon: 'videocam',
    showChilddData: [],
    addMoreInfoShow: true,
    reoveMoreInfoShow: false,
    secandStoryName: '',
    triggernotesids: [],
    stories_length: '',
    inCompleteImages: false,
    completeImages: false,
    showDeleteDialog: false,
    showDeleteDialogMore: false,
    triggerIdDelete: '',
    indexDataDelete: '',
    showDeleteDialogChannel: false,
    vedioSrc: '',
    file1: '',
    showModalForTrgPass: false,
    triggerZonePassword: '',
    triggerZonePassId: '',
    triggerZonePassName: '',
    isLoading: false
  }),
  components: {
    AudioPlayer,
    Loading,
    draggable: draggable
  },
  computed: {
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('library', {stories: 'getStories'}),
    ...mapGetters('routes', ['currentRoute']),
    ...mapGetters('topics', ['currentTopic']),
    ...mapGetters('triggers', {triggersList: 'triggersList', triggerStories: 'storyFiles', currentTrigger: 'currentTrigger'}),
    ...mapGetters('tours', ['currentTour']),
    sortedLanguages: {
      get: function () {
        return this.triggersList;
      },
      set: function (value) {
        this.updateTriggerZoneOrder({triggersList: value});
      }
    }
  },
  methods: {
    ...mapActions('map', ['setCenter']),
    ...mapActions('editor', ['toggleShowSettings']),
    ...mapActions('editor', ['toggleShowTriggerTabs']),
    ...mapActions('library', ['loadStories']),
    ...mapActions('triggers', ['assignStoryFiles', 'assignStory', 'loadTriggerList', 'setCurrentTrigger', 'addNewTrigger', 'clearCurrentTrigger', 'clearStateTriggersList', 'toggleTriggerHovered', 'saveTriggerZone', 'loadRouteTriggers', 'updateTriggerZoneOrder']),
    loadStoryFiles (storyName, storyNameCopy, routeId, triggerId, topicId) {
      if (this.reoveMoreInfoShow === false) {
        // storyNameCopy = '';
      }
      this.assignStoryFiles({
        tourId: this.currentTour.id,
        friendlyName: storyName,
        friendlyNameCopy: storyNameCopy,
        routeId: routeId,
        triggerId: triggerId,
        topicId: topicId
      });
      this.toggleShowSettings(true);
    },
    onUpdate () {
      this.showChilddData = [];
      this.saveUserManualOrder();
    },
    async saveUserManualOrder () {
      let results = await saveTriggerOrder(this.triggersList);
      if (results.data === 'success') {
        var result = await triggerIdsNotes(this.currentTopic.id);
        var list = result.data;
        for (var count = 0; count < list.length; count++) {
          if (list[count]['tzId'] > 0) {
            this.triggernotesids.push(list[count]['tzId']);
          }
        }
        await this.clearCurrentTrigger();
        await this.clearStateTriggersList();
        await this.loadStories({clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id, currentRouteID: this.currentRoute.id});
        let pp = this;
        let response = await checkChannels(this.currentTour.id);
        if (response.data === 'true') {
          pp.isLoading = true;
        }
        this.loadRouteTriggers(this.currentRoute.id).then(() => {
          pp.isLoading = false;
          for (let i = 0; i < this.triggersList.length; i++) {
            let extraStoryId = this.triggersList[i].extra_story_id;
            if (extraStoryId) {
              this.showChilddData.push(i);
            }
          }
        });
        if (this.showChilddData.length > 0) {
          this.addMoreInfoShow = false;
          this.reoveMoreInfoShow = true;
        }
        this.stories_length = this.stories[0].fileLengthSort;
      }
    },
    confirmDeleteMore (triggerId, index) {
      this.showDeleteDialogMore = true;
      this.triggerIdDelete = triggerId;
      this.indexDataDelete = index;
    },
    confirmDelete (triggerId, index) {
      this.showDeleteDialog = true;
      this.triggerIdDelete = triggerId;
      this.indexDataDelete = index;
    },
    MoreInfoFunction (trigger, index) {
      this.triggersList[index].activeInactiveImages = 0;
      this.showChilddData.push(index);
      this.addMoreInfoShow = false;
      this.reoveMoreInfoShow = true;
    },
    async removeMoreInfoFunction (trigger, indexData) {
      this.addMoreInfoShow = true;
      this.reoveMoreInfoShow = false;
      this.showChilddData = this.showChilddData.filter(function (item) {
        return item !== indexData;
      });
      await removeMoreInfo(trigger);
      await this.loadRouteTriggers(this.currentRoute.id);
      this.showDeleteDialogMore = false;
    },
    triggerHasVideo (story) {
      for (let i = 0; i < this.stories.length; i++) {
        if (this.stories[i].friendly_name === story && this.stories[i].isVideo === 1) {
          return true;
        }
      }
      return false;
    },
    assignStoryToTrigger (trigger, triggerRouteId) {
      if (trigger.storyName && (!trigger.oldStoryName || trigger.oldStoryName !== trigger.storyName)) {
        this.assignStory({
          clientId: this.currentClient.id,
          tourId: this.currentTour.id,
          topicId: trigger.toiId,
          triggerId: trigger.id,
          friendly_name: trigger.storyName,
          routeId: triggerRouteId
        });
        this.loadStories({clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id, currentRouteID: triggerRouteId});
        this.loadRouteTriggers(triggerRouteId);
      }
    },
    assignStoryToTriggerCopy (trigger, copy, triggerRouteId) {
      if (trigger.storyNameCopy && (!trigger.oldStoryNameExtra || trigger.oldStoryNameExtra !== trigger.storyNameCopy)) {
        this.assignStory({
          clientId: this.currentClient.id,
          tourId: this.currentTour.id,
          topicId: trigger.toiId,
          triggerId: trigger.id,
          copyStory: copy,
          friendly_name: trigger.storyNameCopy,
          routeId: triggerRouteId
        });
      }
    },
    navToTriggerSettings (trigger) {
      this.setCurrentTrigger(trigger);
      this.setCenter({latLng: this.currentTrigger.latLng});
      this.toggleShowTriggerTabs(true);
      if (this.iconClick === false) {
        this.$router.push('/tour/trigger');
      } else {
        this.$router.push('/tour/trigger/notes');
      }
    },
    goChangeNote (trigger) {
      this.iconClick = true;
    },
    async createTriggerZone () {
      let response = await checkChannels(this.currentTour.id);
      if (response.data === 'true') {
        var newTrigger = {
          id: null,
          name: 'Trigger',
          toiId: this.currentTopic.id,
          routeId: this.currentRoute.id,
          activate: this.currentTour.defaultActivate,
          radiusDistance: this.currentTour.defaultRadiusDistance,
          heading: String(0),
          tolerance: this.currentTour.defaultTolerance,
          triggerMode: 'Queue',
          delay: this.currentTour.defaultDelay,
          isLocked: 0,
          latLng: {lng: this.currentTopic.latLng.lng, lat: this.currentTopic.latLng.lat},
          storyId: null,
          priority: this.currentTour.priority
        };
        this.addNewTrigger(newTrigger).then(() => {
          this.setCenter({latLng: newTrigger.latLng});
          this.toggleShowTriggerTabs(true);
          this.$router.push('/tour/trigger');
        });
      } else {
        this.showDeleteDialogChannel = true;
      }
    },
    async copyTriggerZone (triggerId) {
      let response = await copyTrigger(triggerId);
      if (response.data === 'success') {
        var result = await triggerIdsNotes(this.currentTopic.id);
        var list = result.data;
        for (var count = 0; count < list.length; count++) {
          this.triggernotesids.push(list[count]['tzId']);
        }
        await this.clearCurrentTrigger();
        await this.clearStateTriggersList();
        await this.loadStories({clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id, currentRouteID: this.currentRoute.id});
        await this.loadRouteTriggers(this.currentRoute.id);
        for (let i = 0; i < this.triggersList.length; i++) {
          let extraStoryId = this.triggersList[i].extra_story_id;
          if (extraStoryId) {
            this.showChilddData.push(i);
          }
        }
        if (this.showChilddData.length > 0) {
          this.addMoreInfoShow = false;
          this.reoveMoreInfoShow = true;
        }
        this.stories_length = this.stories[0].fileLengthSort;
      }
    },
    hoverOn (index, triggerName) {
      this.toggleTriggerHovered({index: index, hovered: true, triggerName: triggerName});
    },
    hoverOff (index) {
      this.toggleTriggerHovered({index: index, hovered: false});
    },
    async clickDeleteTrigger (triggerIdDelete, indexDataDelete) {
      const response = await deleteTrigger(triggerIdDelete);
      if (response.status === 200) {
        this.showChilddData = this.showChilddData.filter(function (item) {
          return item !== indexDataDelete;
        });
        this.clearCurrentTrigger();
        this.clearStateTriggersList();
        this.loadStories({clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id});
        this.loadRouteTriggers(this.currentRoute.id);
        this.triggerIdDelete = '';
        this.indexDataDelete = '';
        this.showDeleteDialog = false;
      }
    },
    playVideMp3 (fileUrlVA, type) {
      if (!fileUrlVA) {
        return;
      }
      if (Number(type) === 1) {
        this.$modal.hide('audio-file-play');
        this.$modal.show('video-file-play');
        this.vedioSrc = fileUrlVA;
        let vid = document.getElementById('video-container');
        vid.play();
      } else {
        this.$modal.hide('video-file-play');
        this.$modal.show('audio-file-play');
        this.file1 = fileUrlVA;
      }
    },
    createPassword (triggerId, triggerName) {
      this.showModalForTrgPass = true;
      this.triggerZonePassId = triggerId;
      this.triggerZonePassName = triggerName;
    }
  },
  async mounted () {
    var result = await triggerIdsNotes(this.currentTopic.id);
    var list = result.data;
    for (var count = 0; count < list.length; count++) {
      if (list[count]['tzId'] > 0) {
        this.triggernotesids.push(list[count]['tzId']);
      }
    }
    await this.clearCurrentTrigger();
    await this.clearStateTriggersList();
    await this.loadStories({clientId: this.currentClient.id, tourId: this.currentTour.id, topicId: this.currentTopic.id, currentRouteID: this.currentRoute.id});
    let pp = this;
    let response = await checkChannels(this.currentTour.id);
    if (response.data === 'true') {
      pp.isLoading = true;
    }
    this.loadRouteTriggers(this.currentRoute.id).then(() => {
      pp.isLoading = false;
      for (let i = 0; i < this.triggersList.length; i++) {
        let extraStoryId = this.triggersList[i].extra_story_id;
        if (extraStoryId) {
          this.showChilddData.push(i);
        }
      }
    });
    if (this.showChilddData.length > 0) {
      this.addMoreInfoShow = false;
      this.reoveMoreInfoShow = true;
    }
    this.stories_length = this.stories[0].fileLengthSort;
  }
};
</script>
<style lang="scss">
#triggerZone .scroll-list {
    position: absolute;
    top: 240px;
    bottom: 50px;
    left: 0;
    right: 0;
    overflow: auto;
}

.select-wrap {
    display: flex;
}

.triggers-list .icon-lock_outline:before {
    content: none;
}

.triggers-list .md-button-content {
    width: 100%;
}

.triggers-list .md-field {
    padding: 0 !important;
    margin: 0 !important;
    height: 36px !important;
    min-height: 36px !important;
    width: 84%;
}

.triggers-list .md-field i {
    padding: 0 !important;
    margin: 0 !important;
}

.triggers-list .md-select {
    height: 36px !important;
}

.triggers-list .left-item {
    max-width: 230px;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.triggers-list .list-item > .md-button .title-line {
    height: 48px;
    position: relative;
    padding: 0 0 0 16px;
    margin-top: 15px !important;
}

.list-icon {
    width: 24px !important;
}

.md-list-item-text {
    display: inline-block !important;
}

.vid-icon {
    margin: auto 8px;
}

.no-cam-pad {
    padding-left: 27.61px;
}

img.more_info_icon {
    width: 23px;
    height: 23px !important;
    position: relative;
    left: 8px;
    top: 8px;
}

.icon-note {
    height: 23px;
    width: 23px;
    cursor: pointer;
}

#triggerZone .el.settings-el {
    position: absolute;
    right: -12px;
}

#triggerZone .notesicon {
    position: absolute;
    right: 30px;
    top: 55px;
}

.show-lengthTrigger {
    padding-left: 25px;
}

.completeImages {
    width: 8px;
    margin-right: 10px;
}

.tourDescription {
    margin-left: 19px;
}

.videoPLayIcon {
    width: 8%;
}

.full-size-video video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}

.triggers-list .list-item {
    height: 100% !important;
    margin-bottom: 16px;
    position: relative;
    min-height: 105px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TriggersTab.vue